export default __webpack_public_path__ + "static/media/bellIconWhite.4366a248.svg";